const DRIVERS_SUB_ROUTE = {
  DRIVERS_LIST_ROUTE: '/employees/list',
  DRIVERS_NEW_ROUTE: '/employees/new',
  closingDriverRoute: '/employees/closing-driver'
};

const MONITORING_SUB_ROUTE = {
  MONITORING: '/operations/monitoring',
  RESTRICTIONS: '/operations/restrictions',
  NOTIFICATIONS: '/operations/notifications',
  ALERTS: '/operations/alerts'
};

const PROFILE_SUB_ROUTE = {
  ACCOUNT: '/profile/account',
  ACCESS: '/profile/access'
};

const ROLES_SUB_ROUTE = {
  ROLES_CREATE_ROLES: '/roles/create-role',
  ROLES_LIST_ROLES: '/roles/role-list'
};

const ROUTES_SUB_ROUTE = {
  ROUTES_CREATE_ROUTE: '/routes/create-route',
  ROUTES_LIST_ROUTES: '/routes/route-list'
};

const TICKETS_SUB_ROUTE = {
  TICKETS_SALES: '/tickets/sales',
  TICKETS_SOLD: '/tickets/sold',
  TICKETS_REFUNDS: '/tickets/manual-refunds'
};

const LOGISTCI_SUB_ROUTE = {
  NEW_SENDING: '/logistic/new-sending',
  MANAGE: '/logistic/manage',
};

const TRANSACTIONS_SUB_ROUTE = {
  IN_PROGRESS: '/transactions/in-progress',
  FINISHED: '/transactions/finished',
  CONCILIATIONS: '/transactions/conciliations'
};

const UNITS_SUB_ROUTE = {
  LIST: '/units/list',
  CREATE_CONSULT: '/units/create-consult'
};

const VALID_POS_SUB_ROUTE = {
  ASSIGNED: '/valid-pos/assigned',
  ASSIGN: '/valid-pos/assign'
};

const COPNY_SUB_ROUTE = {
  company: '/copny/modify-copny',
  configuration: '/copny/configuration',
  portalWeb: '/copny/portalweb'
}

const LOYALTY_SUB_ROUTE = {
  MANAGE_REWARDS: '/loyalty/rewards',
}

export const ROUTES_ADMIN = {
  ROOT_ROUTE: '/',
  LOGIN_ROUTE: '/login',
  NOT_FOUND_ROUTE: '/404',
  MONITOR_ROUTE: '/operations',
  MONITORING_SUB_ROUTE,
  DRIVERS_ROUTE: '/employees',
  DRIVERS_SUB_ROUTE,
  ROLES_ROUTE: '/roles',
  ROLES_SUB_ROUTE,
  TICKETS_ROUTE: '/tickets',
  TICKETS_SUB_ROUTE,
  LOGISTIC_ROUTE: '/logistic',
  LOGISTCI_SUB_ROUTE,
  LOYALTY_ROUTE: '/loyalty',
  LOYALTY_SUB_ROUTE,
  ROUTES_ROUTE: '/routes',
  ROUTES_SUB_ROUTE,
  UNITS_ROUTE: '/units',
  UNITS_SUB_ROUTE,
  PROFILE_ROUTE: '/profile',
  PROFILE_SUB_ROUTE,
  OFFICE_ROUTE: '/office',
  COPNY_ROUTE: '/copny',
  COPNY_SUB_ROUTE,
  TRANSACTIONS_ROUTE: '/transactions',
  TRANSACTIONS_SUB_ROUTE,
  VALID_POS: '/valid-pos',
  VALID_POS_SUB_ROUTE,
  STATS_ROUTE: '/stats',
  SUSPENDED_ACCESS: '/suspended-access'
};
